import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faq } from "@/content";

export default function FaqList({ limit }) {
  const items = limit ? faq.slice(0, limit) : faq;
  return (
    <Accordion type="single" collapsible className="divide-y divide-line border-y border-line" data-testid="faq-list">
      {items.map((f) => (
        <AccordionItem key={f.id} value={f.id} className="border-0">
          <AccordionTrigger data-testid={`faq-trigger-${f.id}`} className="py-6 text-left font-serif text-xl text-ink hover:no-underline sm:text-2xl">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-6 pr-8 text-base leading-relaxed text-muted">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
